export type RealtimeResource = 'orders' | 'reservations';

export function realtimeStreamPath(restaurantId: string, resource: RealtimeResource): string {
  return `restaurants/${restaurantId}/${resource}/stream`;
}

export const REALTIME_STREAM_URL = /\/restaurants\/[^/]+\/[^/]+\/stream\/?(?:\?|$)/;
